<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        BEM-VINDO AO NOVO REGULAMENTO DO PLANO PECÚLIO
    </h1>
</header>
<main>
    <blockquote class="mt-2 main-content-blockquote">
        <li>
            Conforme publicação no <b>DOU de 17/12/2024</b>, as alterações no Regulamento do Plano Pecúlio foram
            aprovadas pela PREVIC – Superintendência Nacional de Previdência Complementar.
        </li>
        <li>
            O Regulamento aprovado, assim como o “de para” com as alterações realizadas, poderão ser consultados,
            <b>
                <a style="color: #F46201; font-weight: 500;text-decoration: underline;" target="_blank"
                    href="https://fcopel.org.br/plano-peculio-aprovacao-pela-previc/">
                    clique aqui</a>
            </b>.
        </li>
        <li>
            Neste portal você, participante do Plano Pecúlio, poderá escolher a melhor opção entre as disponíveis para o
            período de transição do Regulamento antigo para o novo. O prazo para essa opção é de <b>17/01/2025</b> a
            <b>16/04/2025</b>. Caso não realize a opção dentro deste prazo, automaticamente será presumida a escolha
            pela opção “A” – manutenção do valor de cobertura (indenização) do Plano Pecúlio.
        </li>
        <li>
            A Fundação Copel ressalta que, durante este prazo de escolha, não serão possíveis alterações nos valores
            contratados <b>(no antigo modelo)</b>, uma vez que a base não pode ser alterada até a finalização do período
            de transição.
        </li>
    </blockquote>
    <hr />
    <spinner [show]="loading != 6"></spinner>

    <div
    *ngIf="prazoLimiteExcedido && solicitacoes.length === 0 && loading == 6"
    class="transition-card mb-4 p-4 rounded-2 shadow-sm border border-gray-300 bg-white"
    >
    <div class="d-flex align-items-start mb-2">
      <i class="bi bi-info-circle text-primary me-2 fs-4"></i>
      <h5 class="mb-0">Período de transição <span class="text-danger fw-semibold">encerrado</span> em 16/04/2025</h5>
    </div>
    <p class="mb-2">
      Uma vez que não <strong>foi feita a sua </strong> escolha por nenhuma das opções do período de transição e, de
      acordo com o <strong>§4º do art. 34</strong> do novo Regulamento do Plano Pecúlio, foi feita a presunção pela
      <strong>Opção A</strong>:
    </p>
    <p class="mb-0">
      <strong>Manter a cobertura do meu Plano Pecúlio</strong>, com o ajuste no valor da contribuição, de acordo com a
      faixa etária. 
    </p>
    <p class="mb-2"><strong>Portanto, a partir de maio, a sua nova contribuição para o Plano Pecúlio será de: </strong></p>
  </div>
  


    <div *ngIf="solicitacoes && solicitacoes.length > 0 && loading == 6 || (prazoLimiteExcedido && loading == 6)">
        <h2>Solicitação Finalizada</h2>
        <fieldset>
            <legend>Dados pessoais</legend>
            <section class="row content-revisao content-card-revisao" style="padding: 0.75rem;" *ngIf="dados">
                <div class="px-1 col-xl-4 col-lg-6">
                    <span>Nome:</span>
                    <span>{{dados.pessoa.name}}</span>
                </div>
                <div class="px-1 col-xl-3 col-lg-3">
                    <span>Matrícula:</span>
                    <span>{{dados.pessoa.matricula}}</span>
                </div>
                <div class="px-1 col-xl-3 col-lg-3">
                    <span>CPF:</span>
                    <span>{{dados.pessoa.cpf | cpfCnpj}}</span>
                </div>
            </section>
        </fieldset>


        <fieldset>
            <legend>Meu Plano Pecúlio </legend>
            <section class="row content-revisao content-card-revisao" style="padding: 0.75rem;">
                <div class="px-1 col-md-12 mt-2">
                    <span>Opção Escolhida:</span>
                    <div class="form-check" *ngIf="this.solicitacoes[0]?.opcao == 1 || (prazoLimiteExcedido && solicitacoes.length == 0)">
                        <label class="form-check-label" for="gridRadios1">
                            (<b>A</b>): Manter o valor da cobertura do meu Plano Pecúlio.
                        </label>
                        <table>
                            <thead>
                                <tr>
                                    <th scope="col">Tipo</th>
                                    <th scope="col">Valor do Pecúlio (Cobertura)</th>
                                    <th scope="col">Novo valor de Contribuição Mensal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="meuPlano && meuPlano?.capital_A > 0">
                                    <td>Titular</td>
                                    <td>{{ meuPlano?.capital_A | currency:'BRL' }}</td>
                                    <td>{{ meuPlano?.contribuicao_A | currency:'BRL' }}</td>
                                </tr>
                                <tr *ngIf="meuPlano && meuPlano?.capital_Adicional_A > 0">
                                    <td>Cônjuge</td>
                                    <td>{{ meuPlano?.capital_Adicional_A | currency:'BRL' }}</td>
                                    <td>{{ meuPlano?.contribuicao_Adicional_A |currency:'BRL' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-check" *ngIf="this.solicitacoes[0]?.opcao == 2">
                        <label class="form-check-label" for="gridRadios2">
                            (<b>B</b>): Manter o valor da contribuição mensal atual.
                        </label>
                        <table>
                            <thead>
                                <tr>
                                    <th scope="col">Tipo</th>
                                    <th scope="col">Novo Valor do Pecúlio (Cobertura)</th>
                                    <th scope="col">Valor de Contribuição Mensal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="meuPlano && meuPlano?.capital_B > 0">
                                    <td>Titular</td>
                                    <td>{{ meuPlano?.capital_B | currency:'BRL' }}</td>
                                    <td>{{ meuPlano?.contribuicao_B | currency:'BRL' }}</td>
                                </tr>
                                <tr *ngIf="meuPlano && meuPlano?.capital_Adicional_B > 0">
                                    <td>Cônjuge</td>
                                    <td>{{ meuPlano?.capital_Adicional_B | currency:'BRL' }}</td>
                                    <td>{{ meuPlano?.contribuicao_Adicional_B |currency:'BRL' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-check disabled" *ngIf="this.solicitacoes[0]?.opcao == 3">
                        <label class="form-check-label" for="gridRadios3">
                            (<b>C</b>): Cancelar o Plano, recebendo em parcela única o valor referencial.
                        </label>
                        <table>
                            <thead>
                                <tr>
                                    <th scope="col">Valor Referencial</th>
                                    <th scope="col">{{ meuPlano?.referencial_C | currency:'BRL' }}</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </section>
        </fieldset>
    </div>
    <div *ngIf="(!solicitacoes || solicitacoes.length == 0) && loading == 6 && !prazoLimiteExcedido">
        <mat-vertical-stepper [linear]="true" #stepper>
            <mat-step>
                <ng-template matStepLabel>Antes de fazer a sua escolha, é importante
                    que você revise os seus dados cadastrais</ng-template>
                <div class="subtitle-form">
                    <h6>Dados Pessoais</h6>
                </div>
                <form [formGroup]="formPessoa">
                    <section class="row mt-3 px-0">
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3 px-1">
                            <label class="label-form">Nome *</label>
                            <input class="form-control input-form" formControlName="name" maxlength="70"
                                placeholder="Nome Completo" [disabled]="true">
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 mb-3 px-1">
                            <label class="label-form">N° da Matrícula *</label>
                            <input class="form-control input-form" formControlName="matricula" placeholder="XXX.XXX"
                                [disabled]="true">
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 mb-3 px-1">
                            <label class="label-form">CPF *</label>
                            <input class="form-control input-form" formControlName="cpf" placeholder="XXX.XXX.XXX-XX"
                                mask="XXX.XXX.XXX-XX" [disabled]="true">
                        </div>
                    </section>
                </form>
                <br>
                <div class="subtitle-form">
                    <h6>Endereço</h6>
                </div>
                <form [formGroup]="formContact">
                    <div class="form-body row">
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">CEP *</label>
                            <input class="form-control input-form" formControlName="cep" maxlength="9" mask="00000-000"
                                placeholder="XXXXX-XXX" (input)="cepChanged()"
                                (keyup)="this.formChanged = true;cepChanged();">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('cep')?.touched && !formContact.controls['cep'].valid" [@fadeIn]>
                                Não foi encontrado o CEP informado
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Endereço *</label>
                            <input class="form-control input-form" formControlName="address" maxlength="70"
                                (keyup)="this.formChanged = true">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('address')?.touched && formContact.get('address')?.invalid">
                                O campo Endereço é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Número *</label>
                            <input class="form-control input-form" formControlName="number" maxlength="5"
                                autocomplete="off" (keyup)="this.formChanged = true">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('number')?.touched && formContact.get('number')?.invalid">
                                O campo Número é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Complemento</label>
                            <input class="form-control input-form" formControlName="complement" maxlength="70"
                                autocomplete="off" (keyup)="this.formChanged = true">
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Bairro *</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="district" maxlength="40">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('district')?.touched && formContact.get('district')?.invalid">
                                O campo Bairro é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Caixa Postal</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="postalCode" maxlength="70" autocomplete="off" type="number">
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Município *</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="city">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('city')?.touched && formContact.get('city')?.invalid">
                                O campo Município é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">UF *</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="state" placeholder="Ex: XX">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('state')?.touched && formContact.get('state')?.invalid">
                                O campo UF é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">País *</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="country">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('country')?.touched && formContact.get('country')?.invalid">
                                O campo País é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Telefone Celular *</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="personalPhone" placeholder='(DDD) 9XXXX-XXXX' mask="(XX) XXXXX-XXXX">
                            <span class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('personalPhone')?.touched && formContact.get('personalPhone')?.invalid">
                                Informe um número de telefone válido
                            </span>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Telefone Comercial/Residencial</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="comercialPhone" placeholder="(XX) XXXX-XXXX" mask="(XX) XXXX-XXXX">
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">E-mail *</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="email" placeholder="xxxxxxx@xxxx.com">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('email')?.touched && formContact.controls['email'].invalid && !formContact.controls['email'].hasError('invalidEmailPdv')"
                                [@fadeInOut]>
                                E-mail inválido!
                            </small>
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.controls['email'].hasError('invalidEmailPdv')" [@fadeInOut]>
                                Por favor, informe um e-mail pessoal, não corporativo!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">E-mail Alternativo</label>
                            <input (keyup)="this.formChanged = true" class="form-control input-form"
                                formControlName="secondaryEmail" placeholder="xxxxxxx@xxxx.com">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('secondaryEmail')?.touched && formContact.controls['secondaryEmail'].invalid && !formContact.controls['secondaryEmail'].hasError('invalidEmailPdv')"
                                [@fadeInOut]>
                                E-mail inválido!
                            </small>
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.controls['secondaryEmail'].hasError('invalidEmailPdv') "
                                [@fadeInOut]>
                                Por favor, informe um e-mail pessoal, não corporativo!
                            </small>
                        </div>
                    </div>
                    <div class="form-check form-check-inline col-12 py-1"
                        *ngIf="dados && dados.dependentesSaude && dados.dependentesSaude.length > 0 && formChanged">
                        <input formControlName="replicateDependant" class="form-check-input" type="checkbox"
                            id="inlineCheckbox1" value="option1">
                        <label class="form-check-label label-form" for="inlineCheckbox1">Incluir alteração de
                            endereço para dependentes</label>
                    </div>
                </form>
                <div class="content-stepper-buttons">
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!formContact.valid">Próximo</button>
                </div>
            </mat-step>
            <mat-step *ngIf="formContact.valid">
                <ng-template matStepLabel>Como é meu plano Pecúlio hoje</ng-template>
                <p style="margin: 1rem; font-weight: 500; color: #F46201;">
                    Antes de realizar a escolha por uma das opções do período de transição, verifique as condições
                    atuais do
                    seu Plano Pecúlio:
                </p>
                <ng-template #notPeculio>
                    <div class="row">
                        <div class="col-md-12">
                            <span class="informacao-no-guides">Você não possui Plano Pecúlio!</span>
                        </div>
                    </div>
                </ng-template>
                <section class="row" *ngIf="peculio; else notPeculio">
                    <div class="card-peculio mb-3 col-xl-6 col-lg-6 col-md-12 col-sm-12"
                        *ngFor="let peculioUser of peculio; let i = index;">
                        <h2 class="main__page__h2" style="margin-bottom: 0.25rem;">{{peculioUser.tipoSegurado ==
                            'AGREGADO'
                            ? 'Adicional (Cônjuge/Companheiro(a))' : peculioUser.tipoSegurado | titlecase}}</h2>
                        <div class="row px-0 main__page__content__data__titular"
                            style="font-size:0.875rem; line-height: 2rem;">
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 px-1">
                                <b class="main__page__content__data__titular__title" style="font-weight: 400;">Valor de
                                    Cobertura para Morte Natural: </b>
                                <span style="font-weight: 300;">{{peculioUser.valor | currency:'BRL'}}</span>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 px-1">
                                <b class="main__page__content__data__titular__title" style="font-weight: 400;">Valor de
                                    Cobertura para Morte Acidental: </b>
                                <span style="font-weight: 300;">{{ peculioUser.valorAcidental | currency:'BRL'}}</span>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 px-1">
                                <b class="main__page__content__data__titular__title" style="font-weight: 400;">Valor do
                                    prêmio Mensal: </b>
                                <span style="font-weight: 300;">{{peculioUser.premioMensal | currency:'BRL'}}</span>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 px-1">
                                <b class="main__page__content__data__titular__title" style="font-weight: 400;">Múltiplo:
                                </b>
                                <span style="font-weight: 300;">{{peculioUser.multiplo}}</span>
                            </div>
                        </div>
                        <section class="d-flex content__header__table">
                            <div class="col-xl-4">Beneficiário</div>
                            <div class="col-xl-4">Parentesco</div>
                            <div class="col-xl-4">% de cobertura</div>
                        </section>
                        <section>
                            <div class="d-flex table__card" *ngFor="let beneficiario of peculioUser.beneficiarios">
                                <div class="col-xl-4">{{beneficiario.beneficiario}}</div>
                                <div class="col-xl-4">{{beneficiario.vinculoAfetivo}}</div>
                                <div class="col-xl-4">{{beneficiario.porcentagem}}</div>
                            </div>
                        </section>
                    </div>
                </section>
                <p style="margin: 1rem; font-weight: 500; color: #F46201;">
                    Confira as suas informações. Se necessário, será possível alterar ou atualizar os beneficiários e
                    percentuais após a conclusão do processo.
                </p>
                <div class="content-stepper-buttons">
                    <button class="btn btn-primary" mat-button matStepperNext>Próximo</button>
                </div>
            </mat-step>
            <mat-step *ngIf="formContact.valid">
                <ng-template matStepLabel>Minha nova opção no Plano Pecúlio</ng-template>
                <p style="font-weight: 400;">
                    Prezado participante, de acordo com o
                    <b style="font-weight: 500 !important;">artigo 34 do novo Regulamento do Plano Pecúlio</b>,
                    solicitamos
                    que escolha <b style="font-weight: 500 !important;">SOMENTE UMA</b> entre as 3 opções abaixo. <b
                        style="font-weight: 500 !important;color: #B71C1C;text-decoration: underline;">A opção escolhida
                        será irretratável</b>:
                </p>
                <form [formGroup]="formTitulo">
                    <section class="col-sm-10 mt-2 px-0">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios1" value="1"
                                (click)="this.opcaoEscolhida = true" formControlName="opcao">
                            <label class="form-check-label" for="gridRadios1" style="font-size: 20px !important;">
                                (<b>A</b>): Manter o valor da cobertura do meu Plano Pecúlio.
                            </label>
                            <table>
                                <thead>
                                    <tr>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Valor do Pecúlio (Cobertura)</th>
                                        <th scope="col">Novo valor de Contribuição Mensal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="meuPlano && meuPlano?.capital_A > 0">
                                        <td>Titular</td>
                                        <td>{{ meuPlano?.capital_A | currency:'BRL' }}</td>
                                        <td>{{ meuPlano?.contribuicao_A | currency:'BRL' }}</td>
                                    </tr>
                                    <tr *ngIf="meuPlano && meuPlano?.capital_Adicional_A > 0">
                                        <td>Cônjuge</td>
                                        <td>{{ meuPlano?.capital_Adicional_A | currency:'BRL' }}</td>
                                        <td>{{ meuPlano?.contribuicao_Adicional_A |currency:'BRL' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios2" value="2"
                                (click)="this.opcaoEscolhida = true" formControlName="opcao">
                            <label class="form-check-label" for="gridRadios2" style="font-size: 20px !important;">
                                (<b>B</b>): Manter o valor da contribuição mensal atual.
                            </label>
                            <table>
                                <thead>
                                    <tr>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Novo Valor do Pecúlio (Cobertura)</th>
                                        <th scope="col">Valor de Contribuição Mensal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="meuPlano && meuPlano?.capital_B > 0">
                                        <td>Titular</td>
                                        <td>{{ meuPlano?.capital_B | currency:'BRL' }}</td>
                                        <td>{{ meuPlano?.contribuicao_B | currency:'BRL' }}</td>
                                    </tr>
                                    <tr *ngIf="meuPlano && meuPlano?.capital_Adicional_B > 0">
                                        <td>Cônjuge</td>
                                        <td>{{ meuPlano?.capital_Adicional_B | currency:'BRL' }}</td>
                                        <td>{{ meuPlano?.contribuicao_Adicional_B |currency:'BRL' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-check disabled">
                            <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios3" value="3"
                                (click)="this.opcaoEscolhida = true" formControlName="opcao">
                            <label class="form-check-label" for="gridRadios3" style="font-size: 20px !important;">
                                (<b>C</b>): Cancelar o Plano, recebendo em parcela única o valor referencial.
                            </label>
                            <table>
                                <thead>
                                    <tr>
                                        <th scope="col">Valor Referencial</th>
                                        <th scope="col">{{ meuPlano?.referencial_C | currency:'BRL' }}</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </section>
                    <div class="p-1">
                        <p style="margin: 1rem; font-weight: 500; color: #F46201;">
                            No mês em que o cancelamento for solicitado, a contribuição mensal do Plano Pecúlio será
                            cobrada normalmente.
                        </p>
                        <p style="font-size: 0.75rem;line-height: 1.25rem;">
                            * valores com referência de <b>12/2024</b>
                        </p>
                    </div>
                </form>
                <div class="content-stepper-buttons">
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!this.opcaoEscolhida">Próximo</button>
                </div>
            </mat-step>
            <mat-step *ngIf="formContact.valid && this.opcaoEscolhida && this.formTitulo.get('opcao')?.value == 3">
                <ng-template matStepLabel>Dados bancários para pagamento</ng-template>
                <section style="margin: 0.5rem; color: #d25401 !important; font-weight: 500;font-size: 0.875rem;">
                    <p>
                        O pagamento da parcela única não é permitido em contas salário. Por esse motivo, os titulares
                        que possuem essa modalidade de conta bancária cadastrada deverão obrigatoriamente cadastrar uma
                        outra conta diferente da modalidade conta salário.
                    </p>
                </section>
                <ng-template matStepLabel>Dados Bancários</ng-template>
                <ng-template #naoPossuiDadosBancarios>
                    <section class="content-dados-bancarios" style="font-size: 0.875rem !important;">
                        <div class="nao-possui-dados-bancarios">
                            <p style="color: #D25401; font-weight: 500;">Você não possui dados bancários em nossa
                                base de dados!</p>
                            <p>Por gentileza faça o anexo de um documento bancário para prosseguir com a
                                solicitação!</p>
                        </div>
                        <div class="row col-10 px-0">
                            <a class="link-dadosBancarios" (click)="alterarDadosBancarios()">
                                Alterar dados bancários
                            </a>
                        </div>
                    </section>
                </ng-template>
                <section *ngIf="dados && dados.contaAtiva else naoPossuiDadosBancarios">
                    <section class="content-dados-bancarios"
                        style="font-size: 0.875rem !important;padding: 0.5rem;border-radius: 5px;">
                        <div class="row" *ngIf="dados.contaAtiva">
                            <div class="px-0 col-md-4">
                                <span style="font-weight: 500; margin-right: 0.5rem;">Nome do Banco:</span>
                                <span style="font-weight: 300;">
                                    {{dados.contaAtiva?.banco}} - {{dados.contaAtiva?.bancoDescricao |
                                    uppercase}}</span>
                            </div>
                            <div class=" col-md-4">
                                <span style="font-weight: 500; margin-right: 0.5rem;">Número da Agência:</span>
                                <span style="font-weight: 300;">{{ dados.contaAtiva?.agencia}}</span>
                            </div>
                            <div class=" col-md-4">
                                <span style="font-weight: 500; margin-right: 0.5rem;">Número da Conta:</span>
                                <span style="font-weight: 300;">{{ dados.contaAtiva?.conta}}</span>
                            </div>
                        </div>
                    </section>
                    <div class="row px-0 py-2 col-12 mt-3">
                        <a class="link-dadosBancarios" (click)="alterarDadosBancarios()">
                            Alterar dados bancários
                        </a>
                    </div>
                </section>
                <section style="margin: 0.5rem; color: #d25401 !important; font-weight: 500;font-size: 0.875rem;">
                    <p>
                        Atenção: Caso solicite a alteração dos seus dados bancários, será possível nova alteração
                        somente após o recebimento do valor referencial.
                    </p>
                </section>
                <section class="col-xl-12 p-0 content-form-lista" *ngIf="listaDocumentos.length > 0">
                    <div class="lista-row" *ngFor="let file of listaDocumentos; let i = index">
                        <span>
                            {{file.fileName}}
                        </span>
                        <div class="lista-actions">
                            <fa-icon class="card__header__icon lista-btn-close" size="2x" [icon]="faSquareXmark">
                            </fa-icon>
                        </div>
                    </div>
                </section>
                <div class="content-stepper-buttons">
                    <button class="btn btn-primary" mat-button matStepperNext>Próximo</button>
                </div>
            </mat-step>
            <mat-step *ngIf="formContact.valid && this.opcaoEscolhida">
                <ng-template matStepLabel>Revise a sua escolha:</ng-template>
                <section>
                    <fieldset>
                        <legend>Dados pessoais</legend>
                        <section class="row content-revisao content-card-revisao" style="padding: 0.75rem;"
                            *ngIf="dados">
                            <div class="px-1 col-xl-4 col-lg-6">
                                <span>Nome:</span>
                                <span>{{dados.pessoa.name}}</span>
                            </div>
                            <div class="px-1 col-xl-3 col-lg-3">
                                <span>Matrícula:</span>
                                <span>{{dados.pessoa.matricula}}</span>
                            </div>
                            <div class="px-1 col-xl-3 col-lg-3">
                                <span>CPF:</span>
                                <span>{{dados.pessoa.cpf | cpfCnpj}}</span>
                            </div>
                        </section>
                    </fieldset>
                    <fieldset>
                        <legend>Meu Plano Pecúlio </legend>
                        <section class="row content-revisao content-card-revisao">
                            <div class="px-1 col-md-12 mt-2">
                                <span>Opção Escolhida:</span>
                                <span *ngIf="this.formTitulo.get('opcao')?.value == 1">
                                    (<b>A</b>): Manter o valor do Seguro (Pecúlio), com alteração no valor da
                                    contribuição.</span>
                                <span *ngIf="this.formTitulo.get('opcao')?.value == 2">
                                    (<b>B</b>): Manter o valor da contribuição, com alteração no valor do
                                    Pecúlio.</span>
                                <span *ngIf="this.formTitulo.get('opcao')?.value == 3">
                                    (<b>C</b>): Cancelar o Plano, recebendo em parcela única o valor referencial.</span>
                            </div>
                        </section>
                    </fieldset>
                    <button class="btn btn-primary" sytle="background:#007A47 !important;" mat-button
                        (click)="finalizarSolicitacao()" [disabled]="this.loadingSave && !formContact.valid">
                        <div class="d-flex" *ngIf="loadingSave; else showSpan">
                            <span class="spinner">
                            </span>
                        </div>
                        <ng-template #showSpan>
                            <span>Finalizar Solicitação</span>
                        </ng-template>
                    </button>
                </section>
            </mat-step>
        </mat-vertical-stepper>
    </div>
</main>